import React, { useState, useEffect, useRef } from 'react';
import endpoints from '../../define/endpoints';
import NavigationMenu from '../NavigationMenu/NavigationMenu';
import { BREAKPOINTS } from '../../../constants';
import { useMatchesMinWidth } from '../../hooks/useMatchesMinWidth';
import Cookies from 'universal-cookie';
import SmartSearch from '../SmartSearch/SmartSearch';
import pages from '../../define/pages';
import BlackFridayBanner from '../BlackFriday/BlackFridayBanner';

const Header = ({
  unclickable,
  isTransparent,
  isAbsolute,
  isCheckout,
  showPrefixes,
  ignoredCategories,
  mostPopularCategories,
  categoriesByPopularity,
  hasBanner,
  startDate,
  endDate,
  copy,
  code
}) => {
  const ref = useRef();
  const isDeviceSmallerThanMblLandscape = !useMatchesMinWidth(
    BREAKPOINTS.MBL_HEADER
  );

  const REGULAR_MARGIN = 0;
  const bannerMargin = 3;
  const extraMargin = isDeviceSmallerThanMblLandscape ? 2 : 1.688;

  const cookies = new Cookies();
  var welfareUser = cookies.get('welfare_user') ?? null;
  var cdsUser = document.body.classList.contains('affiliate-cds');

  const [toggleTransparency, setToggleTransparency] = useState(
    isTransparent && window.scrollY === 0
  );
  const isHomepage =
    window.location.pathname === '/' || window.location.pathname === '/en/';
  const isSearchResultsPage = window.location.pathname === pages.catalogue;

  const [showSearch, setShowSearch] = useState(
    isHomepage || isSearchResultsPage ? false : true
  );
  const [componentClicked, setComponentClicked] = useState(false);

  const [marginTop, setMarginTop] = useState(() => {
    const baseMargin =
      isTransparent && (cdsUser || welfareUser) ? extraMargin : REGULAR_MARGIN;
    return baseMargin + (hasBanner && isTransparent ? 0 : 0);
  });

  useEffect(() => {
    const handleScroll = () => {
      if (!componentClicked) {
        setToggleTransparency(isTransparent && window.scrollY === 0);
      }

      const baseMargin =
        isTransparent && (cdsUser || welfareUser)
          ? window.scrollY === 0
            ? extraMargin
            : REGULAR_MARGIN
          : REGULAR_MARGIN;

      // add banner margin only if scrollY is 0
      setMarginTop(
        baseMargin +
        (hasBanner && isTransparent && window.scrollY === 0
          ? 0
          : 0)
      );

      if (isHomepage) setShowSearch(window.scrollY >= 336);
      if (isSearchResultsPage) setShowSearch(window.scrollY >= 100);
    };

    const handleClick = (event) => {
      if (ref.current && event.target instanceof Node) {
        const targetWasComponent = ref.current.contains(event.target);
        setComponentClicked(targetWasComponent);
        setToggleTransparency(
          !targetWasComponent && isTransparent && window.scrollY === 0
        );
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('click', handleClick);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('click', handleClick);
    };
  });

  return (
    <>
      {hasBanner &&
        <BlackFridayBanner
          startDate={startDate}
          endDate={endDate}
          copy={copy}
          code={code}
        />
      }
      <div
        style={{ marginTop: marginTop + 'rem' }}
        ref={ref}
        className={`${isAbsolute ? 'beta-navbar beta-navbar--absolute' : 'beta-navbar'
          } ${toggleTransparency ? 'beta-navbar--transparent' : 'beta-navbar--shadow'
          } ${isCheckout ? ' beta-navbar--checkout' : ''} gap-2xs`}
      >
        <div className="d-flex gap-3xl flex-0-1-auto">
          <div
            className={`beta-navbar__logo flex-0-0-auto
            ${unclickable ? ' beta-navbar__logo--unclickable' : ''}
            ${toggleTransparency ? ' beta-navbar__logo--transparent' : ''}
            ${isAbsolute ? ' beta-navbar__logo--absolute' : ''}
          `}
          >
            <a
              href={`${freedomeConfig.locale === freedomeConfig.baseLocale ? '/' : '/en'
                } `}
            >
              <img
                src={`${endpoints.bucket}images/new/logo-freedome${toggleTransparency ? '-white' : ''
                  }.svg`}
                alt="Freedome logo"
              />
            </a>
          </div>
          {!isDeviceSmallerThanMblLandscape && (
            <div
              className={`d-flex min-w-0 ${showSearch ? 'ui-kit-visible' : 'ui-kit-hidden'
                }`}
            >
              <SmartSearch isNavSearch={true} />
            </div>
          )}
        </div>

        <NavigationMenu
          showSearch={showSearch}
          prefixesAreVisible={showPrefixes ? showPrefixes : '0'}
          isTransparent={!!toggleTransparency}
          ignoredCategories={
            ignoredCategories && JSON.stringify(ignoredCategories)
          }
          mostPopularCategories={mostPopularCategories}
          categoriesByPopularity={categoriesByPopularity}
          hasBanner={hasBanner}
        />
      </div>
    </>
  );
};

Header.defaultProps = {
  unclickable: false,
  isTransparent: true,
  isAbsolute: true,
  isCheckout: false,
  show_prefixes: '1',
  ignoredCategories: false,
};

NavigationMenu.sanitizeProps = (props) => ({
  ...props,
  isTransparent: props.isTransparent === 'true',
  isAbsolute: props.isAbsolute === 'true',
});

export default Header;
